export default __webpack_public_path__ + "static/image8-f258dce33d4be0aa80d98fab77718de8.jpg";